import styled from "styled-components";
import React, { useEffect, useState } from "react";

// keen-slider
import "keen-slider/keen-slider.min.css";
import { useKeenSlider } from "keen-slider/react";

// @ts-ignore
import { Untabbable } from "react-tabindex";

import { useService } from "@xstate/react";

import { productBuilderMachine } from "../../../context/ProductBuilder/machine";
import { getStateKey } from "../../../helpers/getStateKey";
import { getStates } from "../../../helpers/getStates";
import { useDebounce } from "../../../hooks/useDebounce";
import { useWindowSize } from "../../../hooks/useWindowSize";
// import { AddtoCartRibbon } from '../AddtoCartRibbon';
import { Navigation, NavigationNextButton } from "../Navigation";
// import { ToolBar } from '../ToolBar';
import {
  BladeSize,
  BottomRailColour,
  BracketColour,
  CellDesign,
  ChainColour,
  ChainPosition,
  ChainRelease,
  ChainType,
  Colour,
  ColourDay,
  ColourNight,
  CommonValance,
  Complete,
  Configuration,
  DayColour,
  DayFabricPosition,
  DesignerTape,
  DriveControl,
  ExtensionPole,
  Fascia,
  Fitting,
  FrameStyle,
  HoldDownBrackets,
  LiftPosition,
  LightGuards,
  Transparency,
  Lining,
  LiningColour,
  MaterialType,
  MaterialTypeDay,
  MaterialTypeNight,
  MeasureInsurance,
  Measurements,
  MountingSurface,
  NumberOfPanels,
  Operation,
  PanelConfiguration,
  PleatType,
  PleatFinish,
  PowerSupply,
  RailColour,
  RemoteControl,
  RollDirection,
  RoomName,
  Section,
  Shipping,
  SlatSize,
  SmartRelease,
  StackSide,
  TiltControl,
  TiltPosition,
  Track,
  TrackColour,
  VenetianValance,
  WifiHub,
} from "./";
import { SectionImage } from "./SectionImage";
import { SectionWrapper } from "./SectionWrapper";
import { SummaryWrapper } from "../SummaryWrapper";
import { getFormatedPrice } from "../../../helpers/getFormatedPrice";
import { ProductWithMeasurements, TWindow } from "../../../types";
import { getColourSample } from "../../../helpers/getColourSample";
import {
  getPatternImages,
  getRollerDayNightPatternImages,
} from "../../../helpers/getPatternImages";
import { getDayColourSwatchUrl } from "../../../helpers/getDayColourSwatchUrl";
import { BaseLiningImg } from "../../Icon/BaseLiningImg";
import { BasePleatImg } from "../../Icon/BasePleatImg";
import { BaseTransparencyImage } from "../../Icon/BaseTransparencyImage";
import { BaseColourImage } from "../../Icon/BaseColourImage";
import { BaseTransparency } from "../../Icon/Transperncy";
import { Basecolour } from "../../Icon/Basecolour";
import { BasePleat } from "../../Icon/BasePleat";
import { BaseLining } from "../../Icon/BaseLining";
import { WandOption } from "./WandOption";
import { WandColour } from "./WandColour";
import { PullRod } from "./PullRod";
import { PullRodColour } from "./PullRodColour";
// import { getShippingOptions } from '../../../helpers/shipping';

type SectionSliderWrapper = {
  isLoading: boolean;
};

const SectionSliderWrapper = styled.div<SectionSliderWrapper>`
  width: 100%;
  /* Fixes FOUC */
  height: 74vh;
  position: relative;
  flex-wrap: ${({ isLoading }) => (isLoading ? "wrap" : "nowrap")};
  display: flex;

  @media (min-width: 768px) {
    border-bottom: none;
  }

  @media (min-width: 768px) and (max-width: 1023px) {
    height: 100%;
  }

  @media (max-width: 767px) {
    width: 100%;
    height: 100% !important;
    display: flex;
    flex-direction: row;
    align-items: baseline;
    padding-bottom: 0px;
    height: 450px !important;
  }
`;

const SectionContentWrapper = styled.div`
  width: 100%;
  position: relative;
  padding: 36px 0 12px 0;
  border-image: linear-gradient(to right, #26375f 0%, #327388 100%) 1;
  border-bottom: 12px solid transparent;
  height: 450px;

  @media (min-width: 768px) {
    padding: 10px 0 0;
    width: 50%;
    border-bottom: none;
    height: 100%;
    display: flex;
    flex-direction: column;
  }
  @media (min-width: 768px) and (max-width: 1023px) {
    height: 705px;
  }
  @media (max-width: 1023px) {
    width: 100%;
  }

  @media (max-width: 767px) {
    padding: 0;
    height: 100%;
  }
`;

const StyledProductPriceWrapper = styled.div<{ price: string }>`
  width: calc(100% - 120px);
  margin: 0 1rem;
  z-index: 4;

  span {
    width: auto;
    background-color: #fbd402;
    border-radius: 40px;
    border: 5px solid #ffffff;
    padding: 6px 1rem;
    font-size: var(--bs-h4);
    line-height: 22px;
    font-weight: var(--heading-font-weight);
    font-family: var(--bs-font);
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  visibility: ${({ price }) => (price ? "visible" : "hidden")};

  @media (min-width: 768px) {
    height: calc(100% - 225px);
    width: auto;
    order: 2;

    span {
      top: 100%;
      position: relative;
    }
  }

  @media (min-width: 1024px) {
    position: absolute;
    left: 48.7%;
    transform: translateX(-50%);
    visibility: visible;

    span {
      top: 46%;
      position: relative;
    }
  }

  @media (max-width: 1440px) {
    span {
      top: 75%;
      position: relative;
    }
  }

  @media (max-width: 1199px) {
    span {
      top: 110%;
      position: relative;
    }
  }

  @media (max-width: 1023px) {
    height: auto;
    width: auto;
    order: unset;

    span {
      top: -10px;
      font-size: var(--bs-h6);
    }
  }
  @media (max-width: 767px) {
    height: 0;
  }
`;

const StyledProductDiscountWrapper = styled.div`
  margin: 0;
  line-height: 10px;
  font-size: 15px;
  text-decoration: line-through;
`;

const ProgressbarWrapper = styled.div`
  display: flex;
  flex-direction: column;
  position: absolute;
  bottom: -14px;
  left: 50%;
  transform: translateX(-50%);

  @media (max-width: 767px) {
    bottom: 70px;
  }
`;

const Dots = styled.div`
  display: flex;
  padding: 10px 0 5px;
  justify-content: center;

  .dot {
    border: none;
    width: 10px;
    height: 10px;
    background: #c5c5c5;
    border-radius: 50%;
    margin: 0 5px;
    padding: 5px;
    cursor: pointer;
  }

  .dot:focus {
    outline: none;
  }

  .dot.active {
    background: #000;
  }
`;

const PageIndex = styled.span`
  display: flex;
  padding: 0 0 10px;
  justify-content: center;
`;

const StyledProductSwatchImage = styled.div`
  position: relative;
  svg.zoom {
    position: absolute;
    top: 0px;
    width: 30px;
    right: 3px;
  }
`;

const StyledProductSwatch = styled.div`
  cursor: pointer;
  :not(:first-child) {
    border-top: 5px solid #d9d9d9;
  }

  svg {
    max-width: 100%;
    height: auto;
    aspect-ratio: 1;
  }

  img {
    // box-shadow: 0px 3px 6px #00000029;
    // border: 5px solid #D9D9D9;
    // background: #F4F4F4;
    // border-radius: 100%;
  }

  @media (max-width: 767px) {
    bottom: 10px;
    right: 15px;
  }
`;

interface CompletedStates {
  transparency: boolean;
  colour: boolean;
  pleatType: boolean;
  lining: boolean;
  liningColour: boolean;
}

interface CompletedStates1 {
  transparency: string;
  colour: string;
  pleatType: string;
  lining: string;
  liningColour: string;
}

export const Sections = () => {
  const [state, send] = useService(productBuilderMachine);
  const stateKey = getStateKey(state.value);
  const states = getStates(state.context);
  const slideIndex = states.indexOf(stateKey);
  const [isLoading, setIsLoading] = useState(true);
  const {
    custom,
    productWithMeasurements,
    wandblack,
    wandwhite,
  } = state.context;
  const [pageLoading, setPageLoading] = useState(true);
  const [currentSlide, setCurrentSlide] = useState(0);

  // CURTAIN-SPECIFIC: URL params logic for curtain swatches
  const [params, setParams] = useState({
    color: "",
    transparency: "",
    pleat: "",
    lining: "",
  });

  useEffect(() => {
    const searchParams = new URLSearchParams(window.location.search);
    setParams({
      color: searchParams.get("colour") || "",
      transparency: searchParams.get("transparency") || "",
      pleat: searchParams.get("pleatType") || "",
      lining: searchParams.get("lining") || "",
    });
  }, [state]);

  // CURTAIN-SPECIFIC: Track completed states for interface only
  const [completedStates, setCompletedStates] = useState<CompletedStates1>();

  const getCurrentSelection = (stateType: keyof CompletedStates): string => {
    if (state.context.products[0].type !== "Curtain") {
      return "";
    }

    switch (stateType) {
      case "transparency":
        return state.context.custom.transparency || "";
      case "colour":
        return state.context.custom.colour
          ? state.context.custom.colour.split(": ")[1] ||
              state.context.custom.colour
          : "";
      case "pleatType":
        return state.context.custom.pleatType || "";
      case "lining":
        return state.context.custom.lining || "";
      case "liningColour":
        return state.context.custom.liningColour
          ? state.context.custom.liningColour.split(": ")[1] ||
              state.context.custom.liningColour
          : "";
      default:
        return "";
    }
  };

  // Helper function to check if a step has a selection
  const hasSelection = (stateType: keyof CompletedStates): boolean => {
    const selection = getCurrentSelection(stateType);
    return selection !== "" && selection !== undefined && selection !== null;
  };

  useEffect(() => {
    if (state.context.products[0].type === "Curtain") {
      const selections = {
        transparency: getCurrentSelection("transparency"),
        colour: getCurrentSelection("colour"),
        pleatType: getCurrentSelection("pleatType"),
        lining: getCurrentSelection("lining"),
        liningColour: getCurrentSelection("liningColour"),
        currentStep: stateKey,
      };
      setCompletedStates(selections);
    }
  }, [
    state.context.custom.transparency,
    state.context.custom.colour,
    state.context.custom.pleatType,
    state.context.custom.lining,
    state.context.custom.liningColour,
    state.context.custom.configuration,
    state.context.custom.pullRod,
    stateKey,
    state.context.products[0].type,
  ]);

  // Function to determine if icon should be filled - CURTAIN ONLY
  const getIconState = (
    stateType: keyof CompletedStates,
    stateKey: string
  ): boolean => {
    if (state.context.products[0].type !== "Curtain") {
      return false;
    }

    const currentStateKey = getStateKey(state.value);

    // Updated step order to include liningColour
    const stepOrder = [
      "transparency",
      "colour",
      "pleatType",
      "lining",
      "liningColour",
    ];

    const currentStepIndex = stepOrder.indexOf(currentStateKey);
    const targetStepIndex = stepOrder.indexOf(stateKey);

    // Special case for configuration step - show all completed selections
    if (currentStateKey === "configuration") {
      return hasSelection(stateType);
    }

    // If current step index is not found, show completed selections
    if (currentStepIndex === -1) {
      return hasSelection(stateType);
    }

    // Key fix: If we're on the current step, show selection if it exists
    if (currentStateKey === stateKey) {
      return hasSelection(stateType);
    }

    // Key fix: Only show filled icons for steps that come BEFORE the current step AND have selections
    if (targetStepIndex < currentStepIndex && hasSelection(stateType)) {
      return true;
    }

    // Don't show filled icons for future steps or current step without selection
    return false;
  };

  // Reset visited states when going back (but keep completed states)
  const handleBackClick = (): void => {
    if (state.context.products[0].type === "Curtain") {
      // The actual state change will be handled in the useEffect above
      // This is just for triggering the back navigation
    }
  };

  if (pageLoading && slideIndex === 0 && productWithMeasurements != null) {
    send({ type: "MEASURE_INSURANCE" });
    setPageLoading(false);
  }

  const [sliderRef, slider] = useKeenSlider<HTMLDivElement>({
    initial: 0,
    slideChanged(s) {
      setCurrentSlide(s.details().relativeSlide);
    },
    controls: false,
    vertical: false,
    // breakpoints: {
    //   '(min-width: 768px)': {
    //     vertical: true,
    //   },
    // },
    mounted: (slider) => setIsLoading(false),
  });

  const windowSize = useWindowSize();
  const { width: windowWidth, height: windowHeight } = useDebounce(
    windowSize,
    200
  );

  // Re-jig slider if window size changes
  useEffect(() => {
    if (slider === null || !sliderRef.current) return;
    slider.resize();
  }, [windowWidth, windowHeight, slider, sliderRef]);

  // Move to slide if slideIndex changes
  useEffect(() => {
    if (slider === null || !sliderRef.current) return;
    slider.resize();
    slider.moveToSlide(slideIndex);
    setPageLoading(false);
  }, [slideIndex, slider, sliderRef]);

  let displayPrice = 0;
  let measureInsurancePrice = (custom.measureInsurancePrice || 0) as number;
  let fasciaPrice = (custom.fasciaPrice || 0) as number;
  let smartReleasePrice = (custom.smartReleasePrice || 0) as number;
  let lightGuardPrice = (custom.lightGuardPrice || 0) as number;
  let honeycombVerticalCentreOpeningSurchargePrice = (custom.honeycombVerticalCentreOpeningSurchargePrice ||
    0) as number;
  let venetianValancePrice = (custom.venetianValancePrice || 0) as number;
  let trackPrice = (custom.trackPrice || 0) as number;
  let extensionPolePrice = (custom.extensionPolePrice || 0) as number;
  let stainlessSteelChainPrice = (custom.stainlessSteelChainPrice ||
    0) as number;

  // Calculate wand colour price dynamically from variant data
  const getWandColourPrice = () => {
    // Don't charge for wand if wand_option is "No"
    if (custom.wand_option === "No") return 0;

    // Use stored price if available, otherwise calculate from variant data
    if (custom.wand_colour_price && custom.wand_colour_price > 0) {
      return custom.wand_colour_price;
    }

    if (!custom.wand_colour || custom.wand_colour === "no") return 0;

    const selectedWand = custom.wand_colour?.toLowerCase().includes("white")
      ? wandwhite
      : wandblack;
    if (selectedWand?.[0]?.variants?.[0]) {
      return selectedWand[0].variants[0].price;
    }
    return 0;
  };

  let wandColourPrice = getWandColourPrice();
  let trackColourPrice = (custom.track_colour_price || 0) as number;
  let liningColourPrice = (custom.lining_colour_price || 0) as number;

  // Fix dual track pricing: Use track colour price if available, otherwise use basic track price
  if (trackColourPrice > 0) {
    trackPrice = 0; // Zero out basic track price since track colour price includes it
  }
  let highestPrice = 0;

  if (
    productWithMeasurements !== null &&
    productWithMeasurements.data &&
    productWithMeasurements.data.length > 1 &&
    window.location.pathname.includes("roller-day-night") === false
  ) {
    const airFreight = productWithMeasurements.data.filter(
      (product: ProductWithMeasurements) => product.attributes.freight === "air"
    );
    highestPrice = parseFloat(airFreight[0].attributes.price) * 100;
    // Check if this is a curtain type that should NOT have double pricing
    const isCurtain = state.context.products[0]?.type === "Curtain";

    highestPrice =
      custom.configuration &&
      custom.configuration.includes("Centre Opening") &&
      !isCurtain
        ? highestPrice * 2
        : highestPrice;
  } else if (
    productWithMeasurements !== null &&
    productWithMeasurements.data &&
    productWithMeasurements.data.length === 1 &&
    window.location.pathname.includes("roller-day-night") === false
  ) {
    highestPrice =
      parseFloat(productWithMeasurements.data[0].attributes.price) * 100;
    // Check if this is a curtain type that should NOT have double pricing
    const isCurtain = state.context.products[0]?.type === "Curtain";

    highestPrice =
      custom.configuration &&
      custom.configuration.includes("Centre Opening") &&
      !isCurtain
        ? highestPrice * 2
        : highestPrice;
  } else if (
    productWithMeasurements !== null &&
    productWithMeasurements.data &&
    window.location.pathname.includes("roller-day-night") === true
  ) {
    // old code 15 apr display price show with extra 10$
    // const shippingOptions = getShippingOptions(state.context);

    // let airPrice: number = 1000,
    //   seaPrice: number = 1000;

    // shippingOptions.forEach(option => {
    //   if (option.freight === 'air')
    //     airPrice = airPrice + parseFloat(option.price) * 100;
    //   if (option.freight === 'sea')
    //     seaPrice = seaPrice + parseFloat(option.price) * 100;
    // });
    // if (airPrice > 0) {
    //   highestPrice = airPrice;
    // } else {
    //   highestPrice = seaPrice;
    // }
    let dayNightBracketsPrice = 0;
    const _window = window as TWindow;
    if (
      _window.dayNightBrackets !== undefined &&
      window.location.pathname.includes("roller-day-night")
    ) {
      dayNightBracketsPrice =
        _window.dayNightBrackets[0].first_available_variant.price;
    }
    const airFreight = productWithMeasurements.data.filter(
      (product: ProductWithMeasurements) => product.attributes.freight === "air"
    );
    highestPrice = parseFloat(airFreight[0].attributes.price) * 100;
    // Check if this is a curtain type that should NOT have double pricing
    const isCurtain = state.context.products[0]?.type === "Curtain";

    highestPrice =
      custom.configuration &&
      custom.configuration.includes("Centre Opening") &&
      !isCurtain
        ? highestPrice * 2
        : highestPrice;
    highestPrice = window.location.pathname.includes("roller-day-night")
      ? highestPrice +
        parseFloat(airFreight[1].attributes.price) * 100 +
        dayNightBracketsPrice
      : highestPrice;
  }

  let blindPrice =
    custom.dynamicPrice > 0
      ? ((custom.dynamicPrice * 100) as number)
      : highestPrice;

  function calculateDiscountedPrice(originalPrice: number, discountPercentage: number) {
    const discountAmount = originalPrice * (discountPercentage / 100);
    const discountedPrice = originalPrice - discountAmount;
    return discountedPrice * 100;
  }

  displayPrice =
    measureInsurancePrice +
    fasciaPrice +
    smartReleasePrice +
    lightGuardPrice +
    venetianValancePrice +
    extensionPolePrice +
    trackPrice +
    stainlessSteelChainPrice +
    honeycombVerticalCentreOpeningSurchargePrice +
    wandColourPrice +
    trackColourPrice +
    liningColourPrice +
    blindPrice;

  let discountedPrice =
    measureInsurancePrice +
    fasciaPrice +
    smartReleasePrice +
    lightGuardPrice +
    venetianValancePrice +
    extensionPolePrice +
    trackPrice +
    stainlessSteelChainPrice +
    honeycombVerticalCentreOpeningSurchargePrice +
    wandColourPrice +
    trackColourPrice +
    liningColourPrice +
    ((custom as any).colourDiscoutCode && (custom as any).colourDiscoutCode !== "" && !isNaN(parseInt((custom as any).colourDiscoutCode)) && parseInt((custom as any).colourDiscoutCode) > 0
      ? calculateDiscountedPrice((blindPrice / 100), parseInt((custom as any).colourDiscoutCode))
      : blindPrice);

  // For curtains, only show price when productWithMeasurements is available to prevent random addon prices
  // For other products, show price normally
  const isCurtain = state.context.products[0]?.type === "Curtain";
  const price =
    displayPrice > 0 === true &&
    !state.matches("complete") &&
    (isCurtain ? productWithMeasurements !== null : true)
      ? displayPrice.toString()
      : "";

  // CURTAIN-SPECIFIC: Color swatch logic
  let currentColourName =
    typeof state.context.custom.colourNight !== "undefined" &&
    stateKey === "colourNight"
      ? state.context.custom.colourNight.split(": ")[1]
      : typeof state.context.custom.dayColour !== "undefined" &&
        stateKey === "dayColour"
      ? state.context.custom.dayColour.split(" (").shift() || ""
      : typeof state.context.custom.colourDay !== "undefined" &&
        stateKey === "colourDay"
      ? state.context.custom.colourDay.split(": ")[1]
      : typeof state.context.custom.colour !== "undefined" &&
        stateKey === "colour"
      ? state.context.custom.colour.split(": ")[1]
      : "";

  const colourSample = getColourSample(state.context, currentColourName);
  const patternUrl = getPatternImages(state);
  const nightPatternUrl = getRollerDayNightPatternImages(state);
  const dayHoneycombPatternUrl = getDayColourSwatchUrl(state);

  const currentColourSwatch = stateKey.includes("colourNight")
    ? nightPatternUrl
    : stateKey.includes("dayColour")
    ? dayHoneycombPatternUrl
    : patternUrl;

  const colourSwatchImage =
    colourSample && colourSample.featured_image
      ? colourSample.featured_image.src
      : currentColourSwatch;

  return (
    <SectionWrapper>
      <SectionImage>
        <p>Image</p>
      </SectionImage>
      {/* CURTAIN-SPECIFIC: Visual swatches */}
      {state.context.products[0].type === "Curtain" && (
        <div
          style={{
            textAlign: "center",
            display: "flex",
            flexDirection: "column",
            flex:
              windowWidth > 991
                ? "0 0 auto"
                : windowWidth < 768
                ? "0 0 20%"
                : "0 0 auto",
            width:
              windowWidth > 991
                ? windowHeight < 650
                  ? "9.712%"
                  : "9.712%"
                : "90px",
            // maxWidth: windowWidth > 991 ? "185px" : "90px",
            alignSelf: windowWidth > 991 ? "baseline" : "baseline",
          }}
        >
          <StyledProductSwatch>
            <StyledProductSwatchImage>
              <div>
                {/* Enhanced logic: URL params OR state logic with debug info */}
                {(() => {
                  const hasUrlParam = params?.transparency?.length > 0;
                  const hasStateSelection = getIconState(
                    "transparency",
                    "transparency"
                  );
                  const shouldShow = hasUrlParam && hasStateSelection;

                  return shouldShow ? (
                    <BaseTransparency
                      type={
                        completedStates?.transparency || params?.transparency
                      }
                    />
                  ) : (
                    <BaseTransparencyImage />
                  );
                })()}
              </div>
            </StyledProductSwatchImage>
          </StyledProductSwatch>
          <StyledProductSwatch>
            <StyledProductSwatchImage>
              {(() => {
                const hasUrlParam = params?.color?.length > 0;
                const hasStateSelection = getIconState("colour", "colour");
                const shouldShow = hasUrlParam && hasStateSelection;

                // Get the proper color value - prioritize state over URL params
                let colorValue = completedStates?.colour;
                if (!colorValue && params?.color) {
                  // If URL param has the format "Colour: Name", extract just the name
                  colorValue = params.color.includes(": ")
                    ? params.color.split(": ")[1]
                    : params.color;
                }

                return shouldShow ? (
                  <Basecolour color={colorValue} />
                ) : (
                  <BaseColourImage />
                );
              })()}
            </StyledProductSwatchImage>
          </StyledProductSwatch>
          <StyledProductSwatch>
            <StyledProductSwatchImage>
              {(() => {
                const hasUrlParam = params?.pleat?.length > 0;
                const hasStateSelection = getIconState(
                  "pleatType",
                  "pleatType"
                );
                const shouldShow = hasUrlParam && hasStateSelection;

                return shouldShow ? (
                  <BasePleat
                    type={completedStates?.pleatType || params?.pleat}
                  />
                ) : (
                  <BasePleatImg />
                );
              })()}
            </StyledProductSwatchImage>
          </StyledProductSwatch>
          <StyledProductSwatch>
            <StyledProductSwatchImage>
              {(() => {
                const hasUrlParam = params?.lining?.length > 0;
                const hasStateSelection = getIconState("lining", "lining");
                const shouldShow = hasUrlParam && hasStateSelection;

                return shouldShow ? (
                  <BaseLining
                    type={completedStates?.pleatType || params?.pleat}
                    format={completedStates?.lining || params?.lining}
                    color={completedStates?.liningColour}
                  />
                ) : (
                  <BaseLiningImg />
                );
              })()}
            </StyledProductSwatchImage>
          </StyledProductSwatch>
        </div>
      )}
    
        {displayPrice > 0 &&
        (isCurtain ? productWithMeasurements !== null : true) &&
        state?.event?.type !== "COMPLETE" &&
        state?.event?.type !== "ADD_TO_CART" &&
        state?.event?.type !==
          "done.invoke.productBuilder.complete.loading:invocation[0]" ? (
          <StyledProductPriceWrapper price={price}>
            <span>
              {(custom as any).colourDiscoutCode && (custom as any).colourDiscoutCode !== "" && !isNaN(parseInt((custom as any).colourDiscoutCode)) && parseInt((custom as any).colourDiscoutCode) > 0 ? (
                <>
                  <StyledProductDiscountWrapper>{getFormatedPrice((displayPrice / 100).toString())}</StyledProductDiscountWrapper>
                  {getFormatedPrice((discountedPrice / 100).toString())}
                </>
              ) : (
                getFormatedPrice((displayPrice / 100).toString())
              )}
            </span>
          </StyledProductPriceWrapper>
        ) : (
          <></>
        )}
        <SectionContentWrapper>
          {/* <ToolBar /> */}
          {/* <NavigationNextButton /> */}
          <SectionSliderWrapper
            ref={sliderRef}
            className="keen-slider"
            isLoading={isLoading}
            style={{ overflow: "hidden" }}
          >
            {slider && (
              <ProgressbarWrapper>
                <Dots>
                  {[...Array(slider.details().size).keys()].map((id) => {
                    return (
                      <button
                        key={id}
                        // onClick={() => {
                        //   slider.moveToSlideRelative(id)
                        // }}
                        className={
                          "dot" + (currentSlide === id ? " active" : "")
                        }
                      />
                    );
                  })}
                </Dots>
                <PageIndex>{`${currentSlide + 1} of ${
                  slider.details().size
                }`}</PageIndex>
              </ProgressbarWrapper>
            )}
            <NavigationNextButton />
            {states.map((value) => {
              const isCurrent =
                typeof state.value === "string"
                  ? state.matches(value)
                  : Object.keys(state.value).some(
                      (stateValue) => stateValue === value
                    );
              return (
                <Untabbable active={!isCurrent} key={value}>
                  <Section className="keen-slider__slide">
                    {isLoading && <p>Loading</p>}
                    {value === "materialType" && <MaterialType />}
                    {value === "frameStyle" && <FrameStyle />}
                    {value === "colour" && <Colour />}
                    {value === "pleatFinish" && <PleatFinish />}
                    {value === "transparency" && <Transparency />}
                    {value === "lining" && <Lining />}
                    {value === "liningColour" && <LiningColour />}
                    {value === "cellDesign" && <CellDesign />}
                    {value === "driveControl" && <DriveControl />}
                    {value === "fitting" && <Fitting />}
                    {value === "measurements" && <Measurements />}
                    {value === "colourDay" && <ColourDay />}
                    {value === "colourNight" && <ColourNight />}
                    {value === "dayFabricPosition" && <DayFabricPosition />}
                    {value === "stackSide" && <StackSide />}
                    {value === "measureInsurance" && <MeasureInsurance />}
                    {value === "powerSupply" && <PowerSupply />}
                    {value === "remoteControl" && <RemoteControl />}
                    {value === "liftPosition" && <LiftPosition />}
                    {value === "railColour" && <RailColour />}
                    {value === "mountingSurface" && <MountingSurface />}
                    {value === "extensionPole" && <ExtensionPole />}
                    {value === "roomName" && <RoomName />}
                    {value === "shipping" && <Shipping />}
                    {value === "complete" && <Complete />}
                    {value === "numberOfPanels" && <NumberOfPanels />}
                    {value === "panelConfiguration" && <PanelConfiguration />}
                    {value === "bladeSize" && <BladeSize />}
                    {value === "slatSize" && <SlatSize />}
                    {value === "tiltControl" && <TiltControl />}
                    {value === "tiltPosition" && <TiltPosition />}
                    {value === "designerTape" && <DesignerTape />}
                    {value === "materialTypeDay" && <MaterialTypeDay />}
                    {value === "materialTypeNight" && <MaterialTypeNight />}
                    {value === "rollDirection" && <RollDirection />}
                    {value === "wifiHub" && <WifiHub />}
                    {value === "chainPosition" && <ChainPosition />}
                    {value === "chainRelease" && <ChainRelease />}
                    {value === "chainType" && <ChainType />}
                    {value === "chainColour" && <ChainColour />}
                    {value === "lightGuards" && <LightGuards />}
                    {value === "venetianValance" && <VenetianValance />}
                    {value === "commonValance" && <CommonValance />}
                    {value === "bracketColour" && <BracketColour />}
                    {value === "bottomRailColour" && <BottomRailColour />}
                    {value === "holdDownBrackets" && <HoldDownBrackets />}
                    {value === "pleatType" && <PleatType />}
                    {value === "configuration" && <Configuration />}
                    {value === "track" && <Track />}
                    {value === "trackColour" && <TrackColour />}
                    {value === "pullRod" && <PullRod />}
                    {value === "pullRodColour" && <PullRodColour />}
                    {value === "operation" && <Operation />}
                    {value === "smartRelease" && <SmartRelease />}
                    {value === "dayColour" && <DayColour />}
                    {value === "fascia" && <Fascia />}
                    {value === "wand_option" && <WandOption />}
                    {value === "wand_colour" && <WandColour />}
                  </Section>
                </Untabbable>
              );
            })}
          </SectionSliderWrapper>
          {/* <AddtoCartRibbon /> */}
          <Navigation onBackClick={handleBackClick} />
          {state.matches("complete") ? <></> : <SummaryWrapper />}
          {/* <ToolBar /> */}
        </SectionContentWrapper>
   
    </SectionWrapper>
  );
};
